export const HANDLE_LEAVE = 'leaveManagement@handle-leave';
export const CREATE_LEAVE = 'leaveManagement@create-leave';
export const GET_REMAINING_LEAVES = 'leaveManagement@remaining-leaves';

export const UPDATE_LEAVE_STATUS = 'leaveManagement@update-leave-status';

export const FETCH_EMPLOYEES_FOR_CREATE_LEAVE_REQUEST = 'leaveManagement@fetch-employees-create-leave-request';
export const FETCH_EMPLOYEES_FOR_CREATE_LEAVE_SUCCESS = 'leaveManagement@fetch-employees-create-leave-success';
export const FETCH_EMPLOYEES_FOR_CREATE_LEAVE_FAILURE = 'leaveManagement@fetch-employees-create-leave-failure';

export const FETCH_USERS_ROLE_BASED_REQUEST = 'leaveManagement@fetch-users-role-based-request';
export const FETCH_USERS_ROLE_BASED_SUCCESS = 'leaveManagement@fetch-users-role-based-success';
export const FETCH_USERS_ROLE_BASED_FAILURE = 'leaveManagement@fetch-users-role-based-failure';